import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import type { VenueDocument } from "../types/venues.types";

interface FloorPlanDialogProps {
  open: boolean;
  onClose: () => void;
  venueName: string;
  floorPlanFiles: VenueDocument[];
  primaryColor: string;
}

export const FloorPlanDialog: React.FC<FloorPlanDialogProps> = ({
  open,
  onClose,
  venueName,
  floorPlanFiles,
  primaryColor,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: { borderRadius: 3 },
      }}
    >
      <DialogTitle
        sx={{
          color: primaryColor,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Floor Plan - {venueName}
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 400,
          flexDirection: "column",
        }}
      >
        {floorPlanFiles && floorPlanFiles.length > 0 ? (
          floorPlanFiles.map((img) => (
            <img
              key={img.id}
              src={img.file || "/placeholder.svg"}
              alt={`Floor Plan ${img.id}`}
              style={{ maxWidth: "100%", maxHeight: 400, marginBottom: 8 }}
            />
          ))
        ) : (
          <Typography variant="body1" color="text.secondary">
            No floor plan available.
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default FloorPlanDialog;
